/* Bloomistry theme — localization enhancement.
   The server (Shopify Markets) already renders the correct locale + <html dir>.
   This only ENHANCES the native language selector so it submits on change; the
   underlying {% form 'localization' %} stays usable as a normal submit form w/o JS. */
(function(){
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('select[data-locale-select]'),function(sel){
    sel.addEventListener('change',function(){
      var form=sel.closest('form');if(!form)return;
      var input=form.querySelector('input[name="locale_code"]');
      if(input){input.value=sel.value;}
      if(form.requestSubmit)form.requestSubmit();else form.submit();
    });
  });
})();
